import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import { Text } from '@atlaskit/primitives/compiled/text';

import type { Snippet } from '../types/snippet.ts';
import {
	formatInsertCount,
	shouldShowInsertCount,
	shouldShowPrivateLabel,
	shouldShowUsageAndPrivateLabels,
} from '../utils/insertCountUtils.ts';

import { snippetUsageMessages } from './snippetUsage.i18n.ts';

export const SnippetUsageAndPrivateLabels = ({
	snippet,
}: {
	snippet: Snippet;
}): React.JSX.Element | null => {
	const intl = useIntl();
	const showUsage = shouldShowInsertCount(snippet);
	const showPrivate = shouldShowPrivateLabel(snippet);

	if (!shouldShowUsageAndPrivateLabels(snippet)) {
		return null;
	}

	return (
		<>
			{showUsage && (
				<Text size="small" color="color.text.subtle">
					{intl.formatMessage(snippetUsageMessages.snippetUses, {
						formattedCount: formatInsertCount(snippet.insertCount!),
						count: snippet.insertCount!,
					})}
				</Text>
			)}
			{showPrivate && (
				<Text size="small" color="color.text.subtle">
					<FormattedMessage {...snippetUsageMessages.privateLabel} />
				</Text>
			)}
		</>
	);
};
